// extracted by mini-css-extract-plugin
export default {"wrapper":"PA-z","viewport":"QA-z","container":"RA-z","slide":"SA-z"};